import { mapGetters } from 'vuex'
import { getUploadConfig } from '@/utils/upload'
import journal from '@/api/journal'
import { topic } from '@/api/topics'
import CreatePNG from '@/components/createPNG.dialog.vue'
import Add from './add.dialog.vue'
import AddPlannedPaper from './addPlannedPaper.dialog.vue'
import SendEmail from '@/views/editorial-office/manuscripts/dialog/send-email.dialog'
import section from '@/api/section'
import help from '@/utils/help'
import { settingOption } from '@/api/setting'

const guestEditorColumns = [
  {
    title: '',
    enTitle: 'Name',
    width: 200,
    dataIndex: 'name',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Email',
    width: 150,
    dataIndex: 'email',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Affiliations',
    width: 300,
    dataIndex: 'affiliation',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'CV',
    width: 100,
    dataIndex: 'cv',
    slot: 'link'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 120,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: {
    Add,
    AddPlannedPaper,
    SendEmail,
    CreatePNG
  },
  data() {
    return {
      guestEditorColumns,
      isVisable: false,
      isVisablePlannedPaper: false,
      showSendEmail: false,
      journalList: [],
      rules: {},
      params: {
        journalIdList: [],
        editorList: [],
        particleList: [],
        keyword: [],
        showed: false
      },
      topicEditorEmail: '',
      inputData: {},
      categoryList: [],
      pdfType: 'ge-c',
      isVisablePDF: false,
      oldData: {},
      idetifyEditorObj: {},
      topicEditorObj: {},
      download: help.download
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
      country: 'getCountry',
      user: 'getUser'
    })
  },
  async mounted() {
    const id = this.$route.params.id
    if (id) {
      this.getQuery(id)
    }
    this.getJournal()
    this.getRules()
    this.getSection()
    help.closeAutocomplete()
  },
  methods: {
    async getQuery(id) {
      this.params = await topic.query(id)
      this.oldData = JSON.parse(JSON.stringify(this.params))
      this.$set(
        this.params,
        'keywords',
        this.params.keyword ? this.params.keyword.split(';') : []
      )
      this.params.journalIdList = this.params.journalList
        ? this.params.journalList.map(val => {
            return val.id
          })
        : []
      // this.idetifyEditorObj = this.arrObj(this.params.editorList)
      this.idetifyEditorObj = JSON.parse(this.params.editorMap)
      for (let key in this.idetifyEditorObj) {
        this.idetifyEditorObj[key].map((item, index) => {
          item.sort = item.sort ? item.sort : index
        })
      }
      this.params.editorList = this.objArr(this.idetifyEditorObj)
      this.params.editorList.map((item, index) => {
        item.index = item.index ? item.index : index
      })

      // console.log(
      //   this.topicEditorObj,
      //   'topicEditorList',
      //   this.params.editorList
      // )
    },

    // 数据处理
    arrObj(arr) {
      const obj = {}
      arr &&
        arr.map((item, index) => {
          obj[item.identityCode]
            ? (obj[item.identityCode] = [...obj[item.identityCode], item])
            : Object.assign(obj, {
                [item.identityCode]: [item]
              })
        })
      for (let key in obj) {
        obj[key].map((item, index) => {
          item.sort = item.sort ? item.sort : index
          return item
        })
      }
      return obj
    },

    objArr(obj) {
      let arr = []
      for (let key in obj) {
        obj[key].map(item => {
          arr.push(item)
        })
      }
      arr.map((item, index) => {
        item.index = item.index ? item.index : index
      })
      return arr
    },

    async getJournal() {
      this.journalList = await journal.userGet({ released: true })
      const topicEditorList = await settingOption.get({
        type: 'TOPIC_EDITOR_IDENTITY'
      })
      const topicEditorObj = {}
      topicEditorList.map(item => {
        topicEditorObj[item.code] = item.name
      })
      this.topicEditorObj = topicEditorObj
    },
    async getSection() {
      this.categoryList = await section.getAll({
        journalId: this.params.journalId
      })
      this.categoryList.unshift({
        name: 'Select Section',
        id: ''
      })
    },
    async handleUpload(key, files) {
      const file = files[0]
      const pdfFiles = ['flyer']
      const pdfTypes = ['application/pdf']
      let rightType = true
      if (pdfFiles.includes(key)) {
        rightType = pdfTypes.includes(file.type)
      }
      if (!rightType) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType
        })
        return false
      }
      let MS = 2
      if (key === 'flyer') {
        MS = 10
      }
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB'
        })
        return false
      }
      const url = await getUploadConfig(file, `${this.publisherId}/file`)

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }

      this.$set(this.params, key, url)
      this.$set(this.params, key + 'Name', file.name)
    },

    delFile(key) {
      this.params[key] = ''
      this.params[key + 'Name'] = ''
    },

    goToPage(val, name) {
      help.download(val, name)
    },

    async addTopicEditor() {
      this.inputData = {
        journalId: this.params.journalId,
        email: this.topicEditorEmail,
        index: this.params.editorList.length
      }
      this.isVisable = true
    },
    editTopicEditor(key, val) {
      this.params.editorList.filter((item, index) => {
        if (item.id === val.id) {
          val.index = index
        }
      })
      val.journalId = this.params.journalId
      val.__key = key
      this.inputData = val
      this.isVisable = true
    },
    delTopicEditor(key, index) {
      this.$confirm({
        title: 'Are you sure you want to delete this editor?',
        content:
          'Please be aware of once this editor is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        this.idetifyEditorObj[key].splice(index, 1)
        this.params.editorList = this.objArr(this.idetifyEditorObj)
      })
    },
    async setSort(val, key) {
      val.sort((a, b) => {
        return a - b
      })
      this.idetifyEditorObj[key] = val
      this.idetifyEditorObj[key].map((item, index) => {
        item.sort = index
        return item
      })
      this.params.editorList = this.objArr(this.idetifyEditorObj)
    },
    addPlannedPaper() {
      this.inputData = {
        index: this.params.particleList.length
      }
      this.isVisablePlannedPaper = true
    },
    editPlannedPaper(val, index) {
      val.index = index
      this.inputData = val
      this.isVisablePlannedPaper = true
    },
    delPlannedPaper(index) {
      this.params.particleList.splice(index, 1)
    },
    confirm(val) {
      const flag = this.params.editorList.some((item, index) => {
        if (
          index !== val.index &&
          item.email &&
          item.email.toLowerCase() === val.email.toLowerCase()
        ) {
          return true
        }
      })
      if (flag) {
        this.$message.error({
          title: 'Error',
          content:
            'The topic editor already exists, please do not add it again！'
        })
        return
      }
      this.isVisable = false
      this.$set(this.params.editorList, val.index, val)
      this.idetifyEditorObj = this.arrObj(this.params.editorList)
    },
    confirmPlannedPaper(val) {
      this.isVisablePlannedPaper = false
      this.$set(this.params.particleList, val.index, val)
    },
    cancel() {
      this.isVisable = false
      this.isVisablePlannedPaper = false
      this.isVisablePDF = false
    },
    async save(handle = '') {
      const flag = this.$refs['topic-add-form'].validate()
      if (!flag) {
        return
      }
      this.params.keyword = this.params.keywords
        ? this.params.keywords.join(';')
        : ''
      // if (!this.params.editorList.length) {
      //   this.$message.error({
      //     title: 'Error',
      //     content: 'Guest Editor' + this.LANGUAGE[this.language].noEmpty
      //   })
      //   return
      // }
      this.params.editorMap = JSON.stringify(this.idetifyEditorObj)
      this.params.editorList = this.objArr(this.idetifyEditorObj)
      if (this.params.id) {
        const res = await topic.edit(this.params.id, this.params)
        this.oldData.editorList.forEach(item => {
          delete item.version
        })
        res.editorList.forEach(item => {
          delete item.version
        })
        this.$message.success({
          title: 'Success',
          content: `The Topic has been ${handle.toLowerCase() || 'saved'}!`
        })
        this.$router.back(-1)
      } else {
        this.params.released = !!handle
        await topic.add(this.params)
        this.$message.success({
          title: 'Success',
          content: `The Topic has been ${handle.toLowerCase() || 'saved'}!`
        })
        this.$router.back(-1)
      }
    },
    cancelMail() {
      this.showSendEmail = false
      setTimeout(() => {
        // this.$router.back(-1)
      }, 500)
    },
    async reject() {
      this.$confirm({
        title: 'Are you sure you want to reject this application?',
        content:
          'Please be aware of once this application is rejected, the candidate will receive an notification email.',
        type: 'danger',
        icon: 'iconDetails',
        confirmText: 'Reject'
      }).then(async () => {
        this.save('REFUSED')
      })
    },
    async accept() {
      this.$confirm({
        title: 'Are you sure you want to accept this application?',
        content:
          'Please be aware of once this application is accepted, the candidate will receive an notification email.',
        type: 'success'
      }).then(async () => {
        this.save('ACCEPTED')
        // this.sendEmail()
      })
    },
    // 发送邮件
    sendEmail() {
      this.inputData = {
        applySpecialId: this.params.id
      }
      this.showSendEmail = true
    },
    checkExp(val) {
      const reg = /^[a-zA-Z0-9_]+$/
      return reg.test(val)
    },
    getRules() {
      this.rules = {
        journalIdList: [
          {
            required: true,
            min: 1,
            message: 'Journal' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        code: [
          {
            required: true,
            message:
              'Website Abbreviation' + this.LANGUAGE[this.language].noEmpty
          },
          {
            max: 256,
            message: 'Website Abbreviation cannot be more than 256 digts!'
          },
          {
            fun: this.checkExp,
            message: 'Only enter numbers, letters and underscores!'
          }
        ],
        title: [
          {
            required: true,
            message: 'Topic Title' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        endTime: [
          {
            required: true,
            message: 'End Time' + this.LANGUAGE[this.language].noEmpty
          }
        ]
      }
    },
    createCanvans(val, type) {
      this.inputData = val
      this.inputData.specialTitle = this.params.title
      this.pdfType = type
      this.isVisablePDF = true
    }
  }
}
